import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Anchor } from "hesus-ui-kit";
import Header from "../Header";
import {
  RowHeader,
  GridRow,
  PlanningOuter,
  GridItem,
  GridSubItem,
  Labeltext,
} from "../../AddEditDispute.styled";
import "../../AddEditDispute.scss";

import { renderPriceWithCurrency, addSpace } from "@utils/utils";

const DisputePlanning = (props) => {
  const { t, planningLines } = props;

  const getColumnInfo = () => {
    let column = "75% 25%";
    if (planningLines?.length > 1) {
      column = "45% 30% 25%";
    }

    if (
      (planningLines?.length === 1 &&
        planningLines?.[0]?.hesusService.needCombination) ||
      (planningLines?.[0]?.hesusService.needCenter &&
        planningLines?.[0]?.hesusService.needCarrier)
    ) {
      column = "45% 30% 25%";
    }
    return column;
  };

  return (
    <>
      <GridRow column="1fr">
        <Labeltext>{t("DISPUTE_FORM_IMPACTED_PLANNING_LINE")}</Labeltext>
      </GridRow>
      <RowHeader>
        <GridRow
          column={getColumnInfo}
          marginTop="0px"
          marginBottom="0px"
          gridGap="0rem"
        >
          {planningLines?.length > 1 && (
            <>
              <Header
                title="SUPPLIERS_PLANNING_SOLUTION"
                borderRadius="left"
                align="left"
              />
              <Header title="SUPPLIERS_PLANNING_HAULIER" align="left" />
            </>
          )}
          {planningLines?.length === 1 &&
            planningLines[0]?.hesusService?.needCenter && (
              <Header
                title="SUPPLIERS_PLANNING_SOLUTION"
                borderRadius="left"
                align="left"
              />
            )}
          {planningLines?.length === 1 &&
            planningLines[0]?.hesusService?.needCarrier && (
              <Header title="SUPPLIERS_PLANNING_HAULIER" align="left" />
            )}
          <Header title="SUPPLIERS_PLANNING_PLANNED" borderRadius="right" />
        </GridRow>
      </RowHeader>
      <PlanningOuter marginBottom="30px">
        {planningLines?.map((planningLine, lineIndex) => {
          return (
            <GridRow
              column={getColumnInfo}
              marginBottom="0px"
              gridGap="0rem"
              marginTop="0px"
              borderBottom="2px solid rgba(10, 73, 134, 0.3)"
              key={"dispute-planning-" + lineIndex}
            >
              {(planningLines?.length > 1 ||
                planningLine?.hesusService?.needCenter) && (
                <GridItem
                  borderLeft="2px solid rgba(10, 73, 134, 0.3)"
                  borderRight="2px solid rgba(10, 73, 134, 0.3)"
                  alignContent="center"
                >
                  {planningLine.hesusService.needCenter &&
                    (!planningLine.hesusService.needCombination ||
                      (planningLine.hesusService.needCombination &&
                        planningLine.hesusService.needCombinationCarrier)) && (
                      <GridRow
                        column="70% 30%"
                        marginBottom="0px"
                        marginTop="0px"
                        gridGap="0rem"
                      >
                        <div>
                          <GridSubItem
                            color="#0A4986"
                            padding="5px 5px 0px 10px"
                            fontWeight="700"
                            fontSize="16px"
                          >
                            <Anchor
                              color="#0a4986"
                              url={`/site/view/${planningLine?.solution?.solutionId}/general-info`}
                              target="_blank"
                              className="add-edit-dispute__link"
                            >
                              {`#${planningLine?.solution?.solutionId}`}
                            </Anchor>
                            {planningLine?.solution?.centre?.supplierName
                              ? " - [" +
                                planningLine?.solution?.centre?.supplierName +
                                "]"
                              : ""}
                            {planningLine?.solution?.centre?.name
                              ? " - " + planningLine?.solution?.centre?.name
                              : ""}
                          </GridSubItem>
                          <GridSubItem
                            fontWeight="400"
                            fontSize="16px"
                            color="#474747"
                            fontStyle="italic"
                            padding="0px 5px 5px 10px"
                          >
                            {planningLine?.solution?.product?.name}
                          </GridSubItem>
                        </div>
                        <GridSubItem
                          fontWeight="700"
                          fontSize="16px"
                          textAlign="right"
                          color="#474747"
                          alignContent="center"
                        >
                          {renderPriceWithCurrency(
                            addSpace(planningLine?.solution?.purchasePrice),
                            t(planningLine?.solution?.purchaseUnit),
                            planningLine.solution?.currency?.symbol,
                            planningLine.solution?.currency?.position
                          )}
                        </GridSubItem>
                      </GridRow>
                    )}
                </GridItem>
              )}
              {(planningLines?.length > 1 ||
                planningLine?.hesusService?.needCarrier) && (
                <GridItem
                  alignContent="center"
                  borderLeft={
                    planningLines?.length === 1 &&
                    !planningLine?.hesusService?.needCenter
                      ? "2px solid rgba(10, 73, 134, 0.3)"
                      : "0px solid rgba(10, 73, 134, 0.3)"
                  }
                >
                  {planningLine.hesusService.needCarrier &&
                    (!planningLine.hesusService.needCombination ||
                      (planningLine.hesusService.needCombination &&
                        planningLine.hesusService.needCombinationCenter)) && (
                      <GridRow
                        column="70% 30%"
                        marginBottom="0px"
                        marginTop="0px"
                        gridGap="0rem"
                      >
                        <div>
                          <GridSubItem
                            color="#0A4986"
                            padding="5px 5px 0px 10px"
                            fontWeight="700"
                            fontSize="16px"
                          >
                            {planningLine?.haulage?.company?.name}
                          </GridSubItem>
                          <GridSubItem
                            fontWeight="400"
                            fontSize="16px"
                            color="#474747"
                            fontStyle="italic"
                            padding="0px 5px 5px 10px"
                            alignContent="center"
                          >
                            {planningLine?.haulage?.transport?.name}
                          </GridSubItem>
                        </div>
                        <GridSubItem
                          fontWeight="700"
                          fontSize="16px"
                          textAlign="right"
                          color="#474747"
                          alignContent="center"
                        >
                          {renderPriceWithCurrency(
                            addSpace(planningLine?.haulage?.purchasePrice),
                            t(planningLine?.haulage?.purchaseUnit),
                            planningLine.haulage?.currency?.symbol,
                            planningLine.haulage?.currency?.position
                          )}
                        </GridSubItem>
                      </GridRow>
                    )}
                </GridItem>
              )}
              <GridSubItem
                fontWeight="700"
                fontSize="16px"
                textAlign="center"
                padding="5px 5px 0px 10px"
                borderRight="2px solid rgba(10, 73, 134, 0.3)"
                color="#0A4986"
                alignContent="center"
              >
                {`${planningLine.quantity} ${t(planningLine.unit)}`}
              </GridSubItem>
            </GridRow>
          );
        })}
      </PlanningOuter>
    </>
  );
};

DisputePlanning.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
};
DisputePlanning.defaultProps = {
  id: null,
};

export default withTranslation()(DisputePlanning);
